/*
 * This file was automatically generated. Do not make any changes
 * directly as they may be overwritten.
 *
 * To update this file, run `yarn run generate-api`.
 */
import { apiService } from "assets/scripts/domain/apiService";
/* tslint:disable */
export const ADD_DOCUMENT_URL = "/api/documents/add";
export const GET_DOCUMENTS_URL = "/api/documents";
export function addDocument(model) {
    return apiService.post(ADD_DOCUMENT_URL, true, {
        model
    });
}
export function getDocuments() {
    return apiService.post(GET_DOCUMENTS_URL, true, {});
}
/* tslint:enable */ 



// WEBPACK FOOTER //
// ./src/generated/api/document.ts